import {useApiManager} from "../../../../components/utils/api";
import {
	BillAnnualSummary,
	BillDiscountRestControllerApiFactory,
	BillRestControllerApiFactory,
	DiscountSummary,
	PayrollAnnualSummary,
	PayrollRestControllerApiFactory
} from "arteco-api-client-ts";
import React, {useEffect, useState} from "react";
import {Alert, Button, Grid, Paper, Table, TextField, Typography} from "@mui/material";
import {numberToString} from "../../../../components/utils/numbers";

export const BillHomePage = () => {
	const apiManager = useApiManager();
	const ctrl = apiManager.factory(BillDiscountRestControllerApiFactory);
	const billCtrl = apiManager.factory(BillRestControllerApiFactory);
	const payrollCtrl = apiManager.factory(PayrollRestControllerApiFactory);

	const [costsSummary, setCostsSummary] = useState<PayrollAnnualSummary | undefined>(undefined);
	const [discountSummary, setDiscountSummary] = useState<DiscountSummary | undefined>(undefined);
	const [annualSummary, setAnnualSummary] = useState<BillAnnualSummary | undefined>(undefined);
	const [year, setYear] = useState<number>(new Date().getFullYear());
	const [showPersonDetails, setShowPersonDetails] = useState<boolean>(false);

	useEffect(() => {
		apiManager.execute(ctrl.getSummaryBillDiscount(year))
		.then(resp => {
			setDiscountSummary(resp)
		})

		apiManager.execute(billCtrl.annualSummaryBill(year))
		.then(resp => {
			setAnnualSummary(resp)
		})

		apiManager.execute(payrollCtrl.annualSummaryPayroll(year))
		.then(resp => {
			setCostsSummary(resp)
		})

	}, [year]);

	return (
		<>
			<Typography mt={4} mb={2} variant="h6" color="textSecondary">
				DESCUENTOS APLICABLES
			</Typography>

			<Grid container spacing={3} my={2}>
				<Grid item xs={2}>
					<TextField fullWidth
							   type={"number"}
							   size={"small"}
							   label={"Año"}
							   value={year}
							   onChange={e => setYear(parseInt(e.target.value))}/>
				</Grid>
				<Grid item xs>
					<Alert severity="warning">
						Recuerda indicar el flag de saltar descuento en las facturas que se aplique el rápel
					</Alert>
				</Grid>
			</Grid>


			<Grid container spacing={3}>
				<Grid item xs={4}>
					<Paper elevation={3} style={{padding: 16}}>
						<Typography variant="subtitle1" gutterBottom>
							DESCUENTOS POR CLIENTE
						</Typography>
						<Grid container direction="column" spacing={2}>
							{discountSummary?.lines?.map(ds => (
								<Grid item key={ds.customerShortName}>
									<Typography variant="body1" fontWeight="bold">{ds.customerShortName}</Typography>
									<Table size="small" style={{width: "100%"}}>
										<tbody>
										<tr>
											<td align="right"><b>Facturas</b><br/>{ds.billNum}</td>
											<td align="right">
												<b>Importe<sup>
													<del>IVA</del>
												</sup></b><br/>
												{numberToString(ds.totalAmount)} €
											</td>
										</tr>
										<tr>
											<td align="right"><b>Tipo</b><br/>{ds.discountPct} %</td>
											<td align="right"><b>Ahorro</b><br/>{numberToString(ds.discountSavings || 0)} €</td>
										</tr>
										</tbody>
									</Table>
								</Grid>
							))}
						</Grid>
					</Paper>
				</Grid>

				<Grid item xs={4}>
					<Paper elevation={3} style={{padding: 16}}>
						<Typography variant="subtitle1" gutterBottom>
							FACTURACIÓN ANUAL ACUMULADA (SIN IVA)
						</Typography>

						<Table size="small" style={{width: "100%"}}>
							<tbody>
							{annualSummary && annualSummary.lines?.map(ds => (
								<tr key={"bl-" + ds.customerId}>
									<td>{ds.customerName}</td>
									<td align="right">{numberToString(ds.netAmount)}</td>
								</tr>
							))}
							</tbody>
							<tfoot>
							<tr>
								<td align="right">Total</td>
								<td align="right" style={{fontWeight: "bold"}}>
									{numberToString(
										annualSummary?.lines?.reduce((acc, curr) => acc + (curr.netAmount || 0), 0) || 0
									)}
								</td>
							</tr>
							</tfoot>
						</Table>
					</Paper>
				</Grid>

				<Grid item xs={4}>
					<Paper elevation={3} style={{padding: 16}}>
						<Typography variant="subtitle1" gutterBottom>
							COSTES ANUALES EMPRESA ACUMULADOS
							<Button size={"small"} variant={"outlined"} sx={{ml: 1}}
								onClick={() => setShowPersonDetails(!showPersonDetails)}>
								detalles
							</Button>
						</Typography>
						<Table size="small" style={{width: "100%"}}>
							<tbody>
							{showPersonDetails && costsSummary && costsSummary.lines?.map(ds => (
								<tr key={"bl-" + ds.personId}>
									<td>{ds.personName}</td>
									<td align="right">{numberToString(ds.companyCost)}</td>
								</tr>
							))}
							{!showPersonDetails && (
								<tr>
									<td colSpan={2}>Líneas agrupadas</td>
								</tr>
							)}
							</tbody>
							<tfoot>
							<tr>
								<td align="right">Total</td>
								<td align="right" style={{fontWeight: "bold"}}>
									{numberToString(
										costsSummary?.lines?.reduce((acc, curr) => acc + (curr.companyCost || 0), 0) || 0
									)}
								</td>
							</tr>
							</tfoot>
						</Table>
					</Paper>
				</Grid>
			</Grid>


		</>
	);
};